import React from "react";
import "./App.scss";
import Main from "./containers/Main";
import MarktPilot from "./containers/MarktPilot";
import Water from "./containers/Water";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import AdviceList from "./containers/AdviceList";


function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Main />} />
        <Route path="/marktPilot/:id" element={<MarktPilot />} />
        <Route path="/advices" element={<AdviceList />} />
        <Route path="/water" element={<Water />} />
        <Route path="/water/:id" element={<Water />} />
        <Route path="*" element={<Main />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
